import { ArticleType, AttachmentType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { Divider, Typography } from '@mui/material';
import { Dispatch, Fragment, SetStateAction, useEffect, useMemo, useState } from 'react';
import ExtractedImagesFromFile from './ExtractedImagesFromFile';
import { downloadFilesWithUrls } from '@buildwise/libs/helpers';
import RenderLLMMarkdown from '@buildwise/pages/buildwiseAdmin/BuildWiseGPT/RenderLLMMarkdown';

type RenderParsedDraftsProps = {
  response: any;
  downloadedFiles: AttachmentType[];
  setDownloadedFiles: Dispatch<SetStateAction<AttachmentType[]>>;
};

function RenderParsedDrafts({
  response,
  downloadedFiles,
  setDownloadedFiles,
}: RenderParsedDraftsProps) {
  const { articles, extractedAttachmentsMetaData } = useMemo(
    () => ({
      articles: (response?.metadata?.articlesList || []) as ArticleType[],
      extractedAttachmentsMetaData: response?.metadata?.documentMetadata,
    }),
    [response],
  );
  const [isDownloadingFiles, setDownloadingFiles] = useState(false);

  useEffect(() => {
    if (extractedAttachmentsMetaData?.imagesList) {
      const downloadFiles = async () => {
        try {
          setDownloadingFiles(true);
          const files = await downloadFilesWithUrls({
            urls: (extractedAttachmentsMetaData?.imagesList || []).map((file) => ({
              url: file.fileURL,
            })),
          });

          setDownloadedFiles(files);
        } catch (error) {
          console.log('DOWNLOAD_FILES_ERROR: ' + error);
        } finally {
          setDownloadingFiles(false);
        }
      };

      downloadFiles();
    }
  }, [extractedAttachmentsMetaData?.imagesList]);

  return (
    <>
      {articles.map((article, index) => (
        <Fragment key={article.id}>
          <Typography
            variant="h3"
            sx={(theme) => ({
              fontSize: 18,
              fontWeight: 700,
              color: theme.palette.custom.tuna,
              margin: '12px 0 4px',
            })}
          >
            {article.title}
          </Typography>
          <RenderLLMMarkdown llmResponse={article.description} />
          <ExtractedImagesFromFile
            downloadedFiles={downloadedFiles}
            isDownloadingFiles={isDownloadingFiles}
          />
          {index !== articles.length - 1 && <Divider />}
        </Fragment>
      ))}
    </>
  );
}

export default RenderParsedDrafts;
